/**
 *
 * ResultEnps
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import { Doughnut } from "react-chartjs-2"
import { Popover } from "antd"
import { isEqual } from "lodash"
import Carita_roja from "../../../../../images/Carita_roja.svg"
import Carita_amarilla from "../../../../../images/Carita_amarilla.svg"
import Carita_verde from "../../../../../images/Carita_verde.svg"
import "./index.less"
import imgenps from "../../../../../images/enpsimg.svg"
/* eslint-disable react/prefer-stateless-function */
export class ResultEnps extends React.Component {
  state = {
    climeChart: {
      data: {
        datasets: [
          {
            data: [30, 60, 10],
            borderWidth: 0,
            backgroundColor: ["#5ad0b7", "#f9bf78", "#e88282"],
            weight: 0.3,
          },
        ],
        text: "N/A",
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        responsive: false,
        tooltips: { enabled: false },
        legend: { display: false },
      },
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.setData(nextProps)
    }
  }

  setData = (nextProps) => {
    const { climeChart } = this.state
    climeChart.data.datasets[0].data = [
      nextProps.data.value,
      nextProps.data.value_middle,
      nextProps.data.value_low,
    ]
    climeChart.data.text =
      nextProps.data.value_enps == 0
        ? "N/A"
        : `${parseInt(nextProps.data.value_enps, 10)}%`
    this.setState({ climeChart })
  }

  componentDidMount() {
    if (this.props.data) {
      this.setData(this.props)
    }
  }

  render() {
    const { data, historyMeasure } = this.props
    return (
      <div
        // className="boxShadow ReportHome-enps"
        className={`boxShadow ReportHome-enps ${
          historyMeasure ? "ReportHome-enps-measure-details" : ""
        }`}>
        <Popover
          placement="leftTop"
          content={
            <div style={{ maxWidth: 400 }}>
              <p style={{ textAlign: "justify" }}>
                Las preguntas <b>eNPS</b> (Employee Net Promoter Score) es un
                indicador que mide la fidelidad y el engagement de los
                colaboradores con su organización. Se basa en una pregunta en la
                que los colaboradores tienen que marcar, del 0 al 5, qué tanto
                recomendarían a la empresa como lugar de trabajo a sus amigos o
                familiares.
              </p>
              <p className="text-left">
                <b>¿Cómo se calcula?</b>
              </p>
              <div className="eNPSToolTip__formula">
                <span className="nps-label">eNPS</span>
                <span> = </span>
                <span style={{ color: "#5ad0b7" }}>Promotores(%)</span>
                <span> - </span>
                <span style={{ color: "#e88282" }}>Detractores(%)</span>
              </div>
              <div style={{ margin: "20px 0" }}>
                <img src={imgenps} width="100%" />
              </div>
            </div>
          }
          title="Employee Net Promoter Score"
          trigger="hover">
          <h4>Distribución eNPS</h4>
        </Popover>
        <div style={{ position: "relative" }}>
          <div
            style={{
              position: "relative",
              margin: "40px auto",
              width: "50%",
              minWidth: 130,
              maxWidth: 140,
            }}>
            <Doughnut
              data={this.state.climeChart.data}
              options={this.state.climeChart.options}
              width={140}
            />

            <div className="charteNPS-text">
              {this.state.climeChart.data.text}
            </div>
          </div>
          <div className="leyenda">
            <div className="leyenda__rojo">
              <img src={Carita_roja} />
              <span className="porcentaje">
                {data.value_low_visible || "-"}
              </span>
              <div className="nombre">
                Detractores{" "}
                <span className="total">({data.employees_low || ""})</span>
              </div>
            </div>
            <div className="leyenda__amarillo">
              <img src={Carita_amarilla} />
              <span className="porcentaje">
                {" "}
                {data.value_middle_visible || "-"}
              </span>
              <div className="nombre">
                Pasivos{" "}
                <span className="total">({data.employees_middle || ""})</span>
              </div>
            </div>
            <div className="leyenda__verde">
              <img src={Carita_verde} />
              <span className="porcentaje">{data.value_visible || "-"}</span>
              <div className="nombre">
                Promotores{" "}
                <span className="total">({data.employees_top || ""})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ResultEnps.propTypes = { dispatch: PropTypes.func.isRequired }

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(ResultEnps)
